
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"2","y":"2","width":"36","height":"36"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.89 26.378l-2.512 2.51L20 22.512l-6.377 6.378-2.511-2.511L17.488 20l-6.378-6.378 2.512-2.51L20 17.488l6.378-6.378 2.511 2.511L22.512 20l6.377 6.378zM20 2.222C10.178 2.222 2.223 10.178 2.223 20S10.178 37.778 20 37.778c9.823 0 17.778-7.956 17.778-17.778S29.823 2.222 20 2.222z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])
          )
        }
      }
    